export interface IResearchCategory {
  mainCategory: string;
  genericCategory: string;
  category: string;
}

export class ResearchCategory {
  mainCategory: string;
  genericCategory: string;
  category: string;

  constructor(main: string = null, generic: string = null, cat: string = null) {
    this.mainCategory = main;
    this.genericCategory = generic;
    this.category = cat;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/IResearchCategory.ts